import {
  fetchAllDevices,
  fetchDeviceDetailsBySerial,
} from "../controllers/devices-controller";
import listDevices from "./listDevices";

export const getStructuredDeviceList = async () => {
  try {
    const devices = await fetchAllDevices();

    if (!Array.isArray(devices) || devices.length === 0) {
      throw new Error("No se pudo obtener la lista de dispositivos.");
    }

    const depDevicesResponses = await Promise.all(
      devices.map((device) => fetchDeviceDetailsBySerial(device.serial_number))
    );

    const depDevices = depDevicesResponses
      .map((res) => res?.devices || {})
      .filter(Boolean);

    const mergedData = devices
      .filter((device) => device.udid && device.serial_number)
      .map((device) => {
        const serial = device.serial_number;

        const depObj = depDevices.find((d) => d[serial]) || {};
        const depDetail = depObj[serial] || {};

        const imgDetail =
          listDevices.find((d) => d.model === depDetail.model) || {};

        return {
          uuid: device.udid,
          serial_number: serial,
          model: depDetail.model || "Desconocido",
          description: depDetail.description || "",
          color: depDetail.color || "",
          profile_status: depDetail.profile_status || "unknown",
          profile_assign_time: depDetail.profile_assign_time || "",
          img: imgDetail.img || null,
        };
      });

    return mergedData;
  } catch (err) {
    console.error("❌ Error en getStructuredDeviceList:", err);
    throw err; // Se deja propagar para mostrar error en el frontend si es necesario
  }
};
